import React from 'react';

import { IItemOptionModifier } from '@rbi-ctg/menu';
import { ListCardGroup } from 'components/list-card-group';
import { t } from 'state/intl/translations';
import { useProductWizardContext } from 'state/product-wizard-v2';
import useProductWizardFlow from 'state/product-wizard-v2/hooks/use-product-wizard-flow';
import { isCombo } from 'utils/menu';

import { DEFAULT_SLOT_KEY } from '../product-detail-flow/product-item-flow/constants';

import { ModifierListItem } from './modifier-list-item';
import { IModifierTypeUIProps } from './types';
import {
  getSingleSelectedOption,
  logProductModifierCustomization,
  transformSelectedOptionToSelections,
} from './utils';

export const ModifierSingleChoice: React.FC<IModifierTypeUIProps> = ({
  modifier,
  selections,
  onSelectionsChange,
}) => {
  const { isEdit, slotKeyToCustomize } = useProductWizardFlow();
  const {
    updateSingleOrMultipleModifierSelection,
    menuObject,
    singleOrMultipleModifierSelection,
  } = useProductWizardContext();

  const slot = slotKeyToCustomize ? slotKeyToCustomize : DEFAULT_SLOT_KEY;
  const modifierSelection = singleOrMultipleModifierSelection?.[slot];

  const [selectedOptionKey, setSelectedOptionKey] = React.useState(() => {
    if (
      isEdit ||
      isCombo(menuObject) ||
      !modifierSelection?.isPristine ||
      !!modifierSelection.isSaved
    ) {
      return getSingleSelectedOption(selections)?._key;
    }
    return '';
  });

  const handleListItemPress = (option: IItemOptionModifier) => {
    setSelectedOptionKey(option._key);
    logProductModifierCustomization(option.name?.locale ?? '', modifier.name.locale, option._key);
    requestAnimationFrame(() => {
      updateSingleOrMultipleModifierSelection(slotKeyToCustomize || DEFAULT_SLOT_KEY, {
        isPristine: false,
      });
      onSelectionsChange(transformSelectedOptionToSelections(option));
    });
  };

  return (
    <ListCardGroup
      isFullContainer
      header={t('chooseItemAmount', { amount: modifier.maxAmount, itemName: modifier.name.locale })}
      items={modifier.options}
      renderItem={({ item: option }: { item: IItemOptionModifier }) => (
        <ModifierListItem
          key={option._key}
          isSelected={option._key === selectedOptionKey}
          onListItemPress={() => handleListItemPress(option)}
          content={option}
        />
      )}
    />
  );
};
